module.exports = __webpack_public_path__ + "static/media/goodbody.c29e2014.png";